import type { User } from "firebase/auth";
import { mountRaidPage } from "@/mount-raid-page";
import { setTowerImmersiveBattle } from "@/tower/tower-immersive-battle";

let activeClose: (() => void) | null = null;

export async function openRaidModal(user: User): Promise<() => void> {
  if (activeClose) return activeClose;

  const overlay = document.createElement("div");
  overlay.className = "tower-modal raid-modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "สุ่มโจมตีด่าน");

  const backdrop = document.createElement("button");
  backdrop.type = "button";
  backdrop.className = "tower-modal-backdrop";
  backdrop.setAttribute("aria-label", "ปิด");

  const shell = document.createElement("div");
  shell.className = "tower-modal-shell page-dungeon-lobby";
  overlay.append(backdrop, shell);
  document.body.appendChild(overlay);
  document.body.classList.add("has-tower-modal");

  let pageTeardown: (() => void) | null = null;
  let allowBackdropClose = true;

  const close = () => {
    if (!allowBackdropClose) return;
    pageTeardown?.();
    overlay.remove();
    document.body.classList.remove("has-tower-modal");
    document.body.classList.remove("raid-modal-battle");
    setTowerImmersiveBattle(false);
    activeClose = null;
    window.removeEventListener("keydown", onKeyDown);
  };

  activeClose = close;
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") close();
  };
  window.addEventListener("keydown", onKeyDown);
  backdrop.addEventListener("click", () => close());

  pageTeardown = await mountRaidPage(shell, user, {
    asModal: true,
    onRequestClose: close,
    onBattleActiveChange: (active) => {
      allowBackdropClose = !active;
      overlay.classList.toggle("tower-modal--battle", active);
      document.body.classList.toggle("raid-modal-battle", active);
      setTowerImmersiveBattle(false);
    },
  });

  return close;
}
